import React from 'react';
import { useState, useRef, useLayoutEffect,useCallback } from "react";
import blobPath from './MyMapUtils/blobPath';
import fitBounds from './MyMapUtils/fitBounds';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import LoopIcon from '@mui/icons-material/Loop';
import ErrorIcon from '@mui/icons-material/Error';

export default function ActiveDataPanel(props) {
    //タグ編集用ref
    const tagsRef = useRef(null);
    const ActiveDataPanelRef = useRef(null);
    const [infoAreaHeight, setInfoAreaHeight] = useState(0);
    
    const latRef = useRef(null);
    const lngRef = useRef(null);
    const angleRef = useRef(null);
    function getLeft(val,type) {
        //ActiveDataPanelのpadding+InfoAreaのmargin+Itemのpadding+項目名のwidth+span+iconのmargin+iconのsize=131
        var size = 131 + val?.current?.clientWidth;
        return {
            left: size +"px",
            width:type === "angle" ? "92px":"180px"
        };
    }

    //編集内容のクリア+編集モード解除
    function onClear(){
        props.editClear(true);
    }

    //緯度経度、向きのテキストボックスからフォーカスが外れた時の処理
    //いずれかが編集されていた場合は、地図の表示位置を調整
    const onBlurLocationEditArea = useCallback(() => {
        
        let si = props.selectedItem;

        var lat = props.startLatRef.current.value;
        var lng = props.startLngRef.current.value;
        var lat2 = Math.round(lat * 1000000) / 1000000;   //桁の調整
        var lng2 = Math.round(lng * 1000000) / 1000000;   //桁の調整

        var angle = props.angleRef.current.value;
        var angle2 = Math.round(angle * 100) / 100;   //桁の調整
        
        if(si.startLat !== lat2 || si.startLng !==lng2 || si.angle !== angle2){
            props.startLatRef.current.value = lat2;
            props.startLngRef.current.value = lng2;
            props.angleRef.current.value = angle2;
    
            let si = props.selectedItem;
            si.startLat = lat2;
            si.startLng = lng2;
            si.Location.coordinates = [lng2,lat2];
            si.angle = angle2;
            props.setSelectedItem(si);
            props.setIsEditLocationAngle(!props.isEditLocationAngle);
            props.setIsEdit(true);
    
            let LatLng = new window.google.maps.LatLng(lat2, lng2);
            fitBounds(props.map,null,LatLng,props.mapBoundN,props.mapBoundE,props.mapBoundS,props.mapBoundW + 320);
        }
    }, [props]);

    //緯度経度、向きのテキストボックスでEnterを押した時の処理(Enter=編集が確定した時)
    const onKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onBlurLocationEditArea();
        }
    }, [onBlurLocationEditArea]);

    useLayoutEffect(() => {
        // 管理パネルの高さを再計算
        if (ActiveDataPanelRef.current) {
            let margin = 20*2;  //上下のマージン分
            let workArea = 40;
            let photoArea = 196;
            let gap = 10*2;
            var size = ActiveDataPanelRef.current.clientHeight;
            setInfoAreaHeight(
                size - margin - photoArea - gap -workArea +'px'
            );
        }
    }, [props.height]); //ウィンドウ高さが変わったとき
    return (
        <div className={"ActiveDataPanel"} ref={ActiveDataPanelRef}>
            <div className='ActiveDataItem'>
                <div className='ActiveDataItem-workArea'>
                    <Button className='ActiveDataItem-button' title={"キャンセル"}
                        onClick={()=>onClear()}
                        variant="text"
                        disabled={props.isUpdate}
                        size="small"
                        sx={{width:"40px",minWidth:"40px",height:"40px",padding:"0",color:"#444444"}}
                        >
                        <ArrowBackIcon fontSize="large" />
                    </Button>
                    <Button className='ActiveDataItem-button' title={"編集する"}
                        onClick={props.setIsEditMode}
                        variant="contained"
                        sx={props.isEditMode ?{display:"none"}:{}}
                        size="small"
                        >
                        <ModeEditIcon/>
                    </Button>
                    <Button className='ActiveDataItem-button' title={"編集を保存"}
                        onClick={()=>props.updateData(props.selectedItem,tagsRef.current.value)}
                        variant="contained"
                        sx={!props.isEditMode ?{display:"none"}:{}}
                        disabled={props.isUpdate}
                        size="small"
                        id="saveButton"
                        >
                        {!props.isUpdate ? <SaveIcon /> :<LoopIcon className="loop_Icon"/>}
                    </Button>
                </div>
                <div className="ActiveDataItem-photoArea">
                    {props.selectedItem?.PhotoURL === null ?
                        <div className='ActiveDataItem-NoImage'>No Image</div>
                    :
                        <img src={props.selectedItem !== null ?blobPath(props.selectedItem.ThumbnailURL === null ? props.selectedItem.PhotoURL : props.selectedItem.ThumbnailURL): null}
                                aria-hidden="true"
                                alt=""
                                target="_blank"
                                className='ActiveDataItem-photo'
                                decoding="async"/>
                    }
                </div>
                <div style={{height:"100%",width:"100%",display:"flex",flexDirection:"row",justifyContent:"space-between"}}>
                    <div className={'ActiveDataItem-infoArea' + (props.isEditMode? " ActiveDataItem-infoArea-edit" : "")} style={{ height: infoAreaHeight}}>
                        <div className="ActiveDataItem-infoArea-table">
                        <div className='ActiveDataItem-infoArea-title-border'><span className={"ActiveDataItem-infoArea-title"} style={{borderBottom: "1px solid gray",minHeight:"41px"}}>{props.selectedItem?.title}</span></div>
                            <div>
                                <span className={"ActiveDataItem-infoArea-title"}>地図上の位置設定</span>
                                <div className='ActiveDataItem-infoArea-item' style={{display: "flex",flexDirection: "column",gap:"2px"}}>
                                    <div className='ActiveDataItem-infoArea-item-lla'>緯度：
                                        {!props.isEditMode ?
                                            <span ref={latRef}>{props.selectedItem?.startLat}</span>
                                        :
                                            <input type='text' className='LocationEditArea' ref={props.startLatRef}
                                                disabled={props.isUpdate}
                                                onBlur={()=>onBlurLocationEditArea()} onKeyPress={onKeyPress}
                                                defaultValue={props.selectedItem !== null && props.selectedItem.startLat !== null ? props.selectedItem?.startLat:null}>
                                            </input>
                                        }
                                        {!props.isEditMode && (props.selectedItem?.startLat === 0 || !props.selectedItem?.locationSettingFlg) ?
                                            <ErrorIcon color="error" sx={{marginLeft:"10px",height:"24px"}} className='errorIcon'/>
                                            :null
                                        }
                                        <div className="fukidashi" style={getLeft(latRef,"lat")}>
                                            {props.selectedItem?.startLat === 0 ?
                                                <p>無効値が設定されています。</p>
                                            :
                                                <p>平均値が設定されています。</p>
                                            }
                                        </div>
                                    </div>
                                    <div className='ActiveDataItem-infoArea-item-lla'>経度：
                                        {!props.isEditMode ?
                                            <span ref={lngRef}>{props.selectedItem?.startLng}</span>
                                        :
                                            <input type='text' className='LocationEditArea' ref={props.startLngRef}
                                                disabled={props.isUpdate}
                                                onBlur={()=>onBlurLocationEditArea()} onKeyPress={onKeyPress}
                                                defaultValue={props.selectedItem !== null && props.selectedItem.startLng !== null ? props.selectedItem?.startLng:null}>
                                            </input>
                                        }
                                        {!props.isEditMode && (props.selectedItem?.startLng === 0 || !props.selectedItem?.locationSettingFlg) ?
                                            <ErrorIcon color="error" sx={{marginLeft:"10px",height:"24px"}} className='errorIcon'/>
                                            :null
                                        }
                                        <div className="fukidashi" style={getLeft(lngRef,"lng")}>
                                            {props.selectedItem?.startLng === 0 ?
                                                <p>無効値が設定されています。</p>
                                            :
                                                <p>平均値が設定されています。</p>
                                            }
                                        </div>
                                    </div>
                                    <div className='ActiveDataItem-infoArea-item-lla'>向き：
                                        {!props.isEditMode ?
                                            <span ref={angleRef}>{props.selectedItem?.angle}</span>
                                        :
                                            <input type='text' className='LocationEditArea' ref={props.angleRef}
                                                disabled={props.isUpdate}
                                                onBlur={()=>onBlurLocationEditArea()} onKeyPress={onKeyPress}
                                                defaultValue={props.selectedItem !== null && props.selectedItem.angle !== null ? props.selectedItem?.angle:null}>
                                            </input>
                                        }
                                        {!props.isEditMode && (props.selectedItem?.angle === 0 && !props.selectedItem?.directionSettingFlg) ?
                                            <ErrorIcon color="error" sx={{marginLeft:"10px",height:"24px"}} className='errorIcon'/>
                                            :null
                                        }
                                        <div className="fukidashi" style={getLeft(angleRef,"angle")}>
                                            <p>未設定です。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <span className={"ActiveDataItem-infoArea-title"}>タグ</span>
                                <div>
                                    {props.isEditMode ?
                                        <div className='ActiveDataItem-infoArea-item' style={{lineHeight: "30px",display: "flex",justifyContent: "flex-start",flexDirection: "row"}}>
                                            <textarea  id='TB_tags' type="text" style={{width: "100%",height:"70px",resize:"vertical"}}
                                                defaultValue={props.selectedItem !== null && props.selectedItem.tags !== null ? props.selectedItem?.tags?.join(" "):null}
                                                ref={tagsRef}
                                                disabled={props.isUpdate}
                                                onBlur={()=>{
                                                    var text = tagsRef.current.value;
                                                    var new_text = text.replace(/\n/g, "");
                                                    if (new_text !== text) {
                                                        // 元の値と置き換えた値が等しくなければ新しい値に置き換える
                                                        tagsRef.current.value = new_text;
                                                    }
                                                    if(props.selectedItem?.tags?.join(" ") !== tagsRef.current.value){
                                                        props.setIsEdit(true);
                                                    }
                                                }}/>
                                        </div>
                                    :
                                        <div className='ActiveDataItem-infoArea-item'>
                                            {props.selectedItem !== null && props.selectedItem.tags !== undefined && props.selectedItem.tags !== null && props.selectedItem.tags.length !== 0 ? props.selectedItem.tags.map((item,index) =>
                                                <button onClick={()=>props.onTagClick(`#${item}`)} className="link-style-btn photoResult_tag" style={{ fontWeight: 'bold',wordBreak: "break-all",wordWrap: "break-word",textAlign:"left" }} key={index}>#{item}</button> )
                                            :
                                                null
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            <div>
                                <span className={"ActiveDataItem-infoArea-title"}>撮影日時</span>
                                <span className='ActiveDataItem-infoArea-item' style={{lineHeight: "30px"}}>{props.selectedItem?.filmingDateTime}</span>
                            </div>
                            <div>
                                <span className={"ActiveDataItem-infoArea-title"}>アップロード日時</span>
                                <span className='ActiveDataItem-infoArea-item' style={{lineHeight: "30px"}}>{props.selectedItem?.uploadDateTime}</span>
                            </div>
                            <div>
                                <span className={"ActiveDataItem-infoArea-title"}>写真ファイルの位置情報</span>
                                <div className='ActiveDataItem-infoArea-item' style={{display: "flex",flexDirection: "column",gap:"2px"}}>
                                    <span className='ActiveDataItem-infoArea-item-lla'>緯度：{props.selectedItem?.originalData_lat}</span>
                                    <span className='ActiveDataItem-infoArea-item-lla'>経度：{props.selectedItem?.originalData_lng}</span>
                                    <span className='ActiveDataItem-infoArea-item-lla'>向き：{props.selectedItem?.originalData_angle}</span> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
